import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get } from 'lodash';
import axios from '@/axios';

import Icons from '@/icons';
import { iconConstants, routesConstants } from '@/constants';
import { Button } from '@/kaya';
import { useArtistStore } from '@/store';
import { userActions } from '@/actions';
import logo from '@/assets/upperLogin-image.png';

import styles from './EmailVerify.module.scss';

const EmailVerify = () => {
  const [searchParams, setSeararams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const { setArtist, setAuthentication, defaultArtist } = useArtistStore();

  const ref = useRef(false);

  useEffect(() => {
    if (ref.current) return;

    const verifyEmail = async () => {
      ref.current = true;

      if (token) {
        const data = await userActions.verifyEmailAction({
          payload: { token },
        });

        if (!data.success) return;

        setArtist({
          ...defaultArtist,
          id: get(data, 'data.id', {}),
        });

        setAuthentication({
          isAuthenticated: true,
          isPhoneVerified: false,
        });

        localStorage.setItem('refresh_token', get(data, 'data.refresh_token', ''));

        axios.defaults.headers.common['Authorization'] = `Bearer ${get(
          data,
          'data.access_token',
          '',
        )}`;

        navigate(routesConstants.ROUTES.PERSONAL_INFO);
      }
    };
    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.EmailVerify}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" className={styles.logoImg} />
      </div>
      <div className={styles.box}>
        <div className={styles.check}>
          <Icons type={iconConstants.ICONS.EMAIL_VERIFY} />
        </div>
        <p className={styles.desc}>Successfully Verified</p>
        <p className={styles.desc2}>
          Congratulations! Your email address has been successfully verified.
        </p>
        <Button
          className={styles.btn}
          onClick={() => {
            navigate(routesConstants.ROUTES.LOGIN);
          }}
          type="Primary"
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default EmailVerify;
